// extracted by mini-css-extract-plugin
export var compactFilters = "_fy-4";
export var detailImage = "_fy-1";
export var dropdownContainer = "_fy-2";
export var imageContainer = "_fy-0";
export var selectedCard = "_fy-3";